/* ============================================================================
   ebarza · 3D Library — additions JS
   · Sticky-header scroll state
   · Custom predictive search bound ONLY to ebarza inputs (no name="q",
     so 3rd-party search apps like Boost / Searchanise don't bind)
   · Form submit → /search?q=<query>+tag:3D-MODEL&type=product (3D-only)
   · Smooth scroll for in-page anchor links
   · MutationObserver-based hider for late-injected app widgets &
     predictive-search popups
   ============================================================================ */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function buildSearchUrl(query) {
    var q = (query || '').trim();
    if (!q) {
      // Empty submit → go to AR-Ready collection sorted newest first
      return '/collections/a-r-ready-products?sort_by=created-descending';
    }
    // Shopify search supports inline operators. tag:3D-MODEL scopes to 3D-tagged products only.
    var qs = encodeURIComponent(q + ' tag:3D-MODEL');
    return '/search?q=' + qs + '&type=product&options%5Bunavailable_products%5D=hide';
  }

  /* ---------- Sticky header scroll state ---------- */
  var header = document.querySelector('.ebarza3d-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 6); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Search dropdown open/close ---------- */
  var trigger    = document.querySelector('.ebarza3d-search-trigger');
  var panel      = document.querySelector('#ebarza3d-search');
  var closeBtn   = document.querySelector('.ebarza3d-search__close');
  var headerInput = panel ? panel.querySelector('[data-ebarza-search-input]') : null;
  var suggest    = document.querySelector('[data-suggest]');
  var suggestRes = document.querySelector('[data-suggest-results]');

  function openSearch() {
    if (!panel) return;
    panel.hidden = false;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    setTimeout(function () { if (headerInput) headerInput.focus(); }, 30);
  }
  function closeSearch() {
    if (!panel) return;
    panel.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (suggest) suggest.hidden = true;
  }
  /* Only wire trigger/close/Escape if the header section's inline JS
     hasn't already done it. The header sets data-search-wired="1" on the
     trigger button to claim ownership; without this guard, both handlers
     would fire on a single click and toggle the panel open-then-closed. */
  if (trigger && trigger.dataset.searchWired !== '1') {
    trigger.dataset.searchWired = '1';
    trigger.addEventListener('click', function () {
      if (panel && panel.hidden) openSearch(); else closeSearch();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && !panel.hidden) closeSearch();
    });
  }

  /* ---------- Custom predictive search (3D-only)
     Bound ONLY to inputs with [data-ebarza-search-input]. We DO NOT use
     name="q" anywhere, so 3rd-party search apps don't bind to these inputs. */

  var searchTimer = null;
  var lastReqId = 0;

  function renderSuggestions(products, query) {
    if (!suggestRes) return;
    if (!products.length) {
      suggestRes.innerHTML =
        '<div class="ebarza3d-suggest__empty">' +
          '<p class="eyebrow text-taupe">No 3D-ready matches</p>' +
          '<p>No products with a 3D file match <strong>' + escHtml(query) + '</strong>. Try a broader term.</p>' +
        '</div>';
    } else {
      suggestRes.innerHTML = products.slice(0, 6).map(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var price = p.price || p.compare_at_price || '';
        return '' +
          '<a href="' + escHtml(p.url) + '" class="ebarza3d-suggest__item">' +
            '<span class="ebarza3d-suggest__thumb">' +
              (img ? '<img src="' + escHtml(img) + '" alt="" loading="lazy" />' : '') +
            '</span>' +
            '<span class="ebarza3d-suggest__meta">' +
              '<span class="ebarza3d-suggest__title">' + escHtml(p.title) + '</span>' +
              (price ? '<span class="ebarza3d-suggest__price">' + escHtml(price) + '</span>' : '') +
              '<span class="ebarza3d-suggest__badge">● 3D · .glb · .usdz</span>' +
            '</span>' +
          '</a>';
      }).join('');
    }
    var viewAll = document.querySelector('[data-suggest-viewall]');
    if (viewAll) {
      viewAll.href = buildSearchUrl(query);
      viewAll.textContent = 'View all 3D matches for "' + query + '" →';
    }
    if (suggest) suggest.hidden = false;
  }

  function fetchSuggestions(query) {
    var reqId = ++lastReqId;
    // Predictive search API. We use it (vs filtering tags client-side)
    // because Shopify suggest endpoint doesn't accept a tag filter directly.
    // We over-fetch (limit=30) then filter by 3D-MODEL tag client-side.
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
              '&resources[type]=product' +
              '&resources[limit]=30' +
              '&resources[options][unavailable_products]=hide' +
              '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (reqId !== lastReqId) return;
        var all = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var threeD = all.filter(function (p) {
          var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
          return tags.indexOf('3d-model') !== -1 || tags.indexOf('3d_model') !== -1;
        });
        renderSuggestions(threeD, query);
      })
      .catch(function () { if (suggest) suggest.hidden = true; });
  }

  // Bind input handler to BOTH search inputs (header & in-page FIND bar)
  var searchInputs = document.querySelectorAll('[data-ebarza-search-input]');
  searchInputs.forEach(function (input) {
    input.addEventListener('input', function (e) {
      // Stop the event from bubbling to any 3rd-party search-app listener.
      e.stopPropagation();
      var q = e.target.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) {
        if (input === headerInput && suggest) suggest.hidden = true;
        return;
      }
      // Predictive dropdown only renders in the header (where the markup exists)
      if (input === headerInput) {
        searchTimer = setTimeout(function () { fetchSuggestions(q); }, 180);
      }
    });
    // Block bubbling on focus too — some apps open their popup on focus.
    input.addEventListener('focus', function (e) { e.stopPropagation(); });
    input.addEventListener('click', function (e) { e.stopPropagation(); });
  });

  /* ---------- Form submit → redirect to filtered /search ---------- */
  var searchForms = document.querySelectorAll('[data-ebarza-search-form]');
  searchForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var input = form.querySelector('[data-ebarza-search-input]');
      var query = input ? input.value : '';
      window.location.href = buildSearchUrl(query);
    });
  });

  /* ---------- Close suggest panel when clicking outside ---------- */
  document.addEventListener('click', function (e) {
    if (!panel || panel.hidden) return;
    if (!panel.contains(e.target) && trigger && !trigger.contains(e.target)) {
      closeSearch();
    }
  });

  /* ---------- Smooth scroll for anchor nav links ---------- */
  document.querySelectorAll('a[data-scroll]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href') || '';
      var hashIdx = href.indexOf('#');
      if (hashIdx < 0) return;
      var id = href.slice(hashIdx + 1);
      var target = document.getElementById(id);
      if (!target) return;
      if (href.startsWith('#') || href.startsWith('/pages/3d-library')) {
        e.preventDefault();
        var headerH = (header && header.offsetHeight) || 72;
        var top = target.getBoundingClientRect().top + window.scrollY - headerH - 12;
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.replaceState(null, '', '#' + id);
        closeSearch();
      }
    });
  });

  /* ---------- Tabbed Categories ---------- */
  var catsRoot       = document.querySelector('.ebarza3d-cats');
  var catsTabs       = document.querySelectorAll('[data-cats-tab]');
  var catsSubtabsBar = document.querySelector('[data-cats-subtabs]');
  var catsSubtabs    = document.querySelectorAll('[data-cats-subtab]');
  var catsPanels     = document.querySelectorAll('[data-cats-panel]');

  function showCatsPanel(panelKey) {
    if (!catsPanels.length) return;
    catsPanels.forEach(function (p) {
      var match = p.getAttribute('data-cats-panel') === panelKey;
      if (match) { p.hidden = false; p.classList.add('is-active'); }
      else       { p.hidden = true;  p.classList.remove('is-active'); }
    });
  }

  function activateCatsTab(tabKey, subKey) {
    catsTabs.forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-cats-tab') === tabKey);
    });
    if (tabKey === 'furniture') {
      if (catsSubtabsBar) catsSubtabsBar.classList.add('is-visible');
      var activeSub = subKey || 'indoor';
      catsSubtabs.forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-cats-subtab') === activeSub);
      });
      showCatsPanel('furniture:' + activeSub);
      history.replaceState(null, '', '#cat=furniture:' + activeSub);
    } else {
      if (catsSubtabsBar) catsSubtabsBar.classList.remove('is-visible');
      showCatsPanel(tabKey);
      history.replaceState(null, '', '#cat=' + tabKey);
    }
  }

  if (catsRoot) {
    catsTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateCatsTab(tab.getAttribute('data-cats-tab'));
      });
    });
    catsSubtabs.forEach(function (sub) {
      sub.addEventListener('click', function () {
        activateCatsTab('furniture', sub.getAttribute('data-cats-subtab'));
      });
    });
    // Default state: furniture tab is visible, so make sub-tabs visible too
    if (catsSubtabsBar) catsSubtabsBar.classList.add('is-visible');

    // Restore from URL hash on load (e.g. #cat=lighting or #cat=furniture:outdoor)
    var hash = (window.location.hash || '').replace(/^#/, '');
    var m = hash.match(/cat=([^&]+)/);
    if (m) {
      var parts = decodeURIComponent(m[1]).split(':');
      activateCatsTab(parts[0], parts[1]);
    }
  }

  /* ---------- App-widget + foreign search-popup hider ---------- */
  var APP_RX = [
    /whatsapp/i, /wa-chat/i, /wa-widget/i, /wa[-_]?button/i,
    /reviews?[-_]?tab/i, /reviews?[-_]?widget/i, /productreviews/i,
    /growave/i, /loox/i, /judge[-_]?me/i, /yotpo/i, /tipo/i,
    /miles/i, /smile[-_]?launcher/i, /gift[-_]?voucher/i,
    /popup[-_]?widget/i, /popup[-_]?window/i,
    /trustpilot/i, /zoko/i, /shopify-app-embed/i,
    // 3rd-party search apps & their predictive popups
    /boost[-_]?pfs/i, /bgsi/i, /boost[-_]?search/i, /^boost-/i,
    /searchanise/i, /snize/i, /snz/i,
    /predictive[-_]?search/i, /instant[-_]?search/i,
    /algolia[-_]?autocomplete/i, /aa-Panel/i,
    /klevu/i, /findify/i, /fast[-_]?simon/i
  ];
  function looksLikeWidget(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.closest('.ebarza3d, .ebarza3d-header, .ebarza3d-footer, #ebarza3d-search, .ebarza3d-suggest, .ebarza3d-allowed')) return false;
    var id  = el.id || '';
    var cls = (typeof el.className === 'string' ? el.className : '') || '';
    return APP_RX.some(function (rx) { return rx.test(id) || rx.test(cls); });
  }
  function hide(el) {
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
  }
  function sweep(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('*').forEach(function (el) { if (looksLikeWidget(el)) hide(el); });
  }
  sweep(document.body);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (looksLikeWidget(n)) hide(n);
        if (n.querySelectorAll) sweep(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
